import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { IoIosSwap } from 'react-icons/io';
import { TbDownload, TbTriangleFilled } from 'react-icons/tb';
import { TbTriangleInvertedFilled } from 'react-icons/tb';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { Button } from '@/components/ui/button';
import { toLocaleShortString, toRate, toSpecialFixed } from '@/lib/misc/utils';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import classNames from '@/lib/misc/classNames';
import SlidingModal from '../home/mobile/SlidingModal';
import { useMixpanel } from '@/lib/misc/mixpanel';
import { useSession } from '@/contexts/LitSessionProvider';
import Link from 'next/link';
import SendFundsController from '../asset/sendFunds/SendFundsController';
import { useSwap } from '@/contexts/SwapProvider';
import { TAssetModes } from './AssetsPortfolio';
import { ImageWithFallback } from '../shared/NextImageFallback';
import DepositHome from '../deposit/DepositHome';
import MobileBuySellController from '../asset/mobile/mobileBuySellAsset/MobileBuySellController';
import { useQuery } from '@tanstack/react-query';
import { getUrls } from '@shared/utils/config/environment';
import { TPnLData } from '@shared/types/frontend/assetPage';
import { ChainId } from '@shared/utils/config/networks';
import FlexYourGains from '../asset/FlexYourGains';
import { getTokenImage } from '@/lib/asset/nativeAddressHelper';
interface PortfolioAssetItemProps {
  assetMode: TAssetModes;
  assetItem: any;
  isSwap: boolean;
  assetData: any;
  setLinkClickedLoading?: (boolean) => void;
}

//DO NOT call useTokenData in this component - you get an insane number of requests that clog the network
export const PortfolioAssetItem = ({
  assetMode,
  isSwap,
  assetItem,
  setLinkClickedLoading,
  assetData
}: PortfolioAssetItemProps) => {
  const router = useRouter();
  const {
    PKP
  } = useSession();
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const {
    resetAssets
  } = useSwap();

  //this is necessary for safari gpu issues
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpen1, setModalOpen1] = useState(false);
  const [isDepositOpen, setDepositOpen] = useState(false);
  const [isOpenFlex, setIsOpenFlex] = useState(false);
  function toggleFlex() {
    setIsOpenFlex(!isOpenFlex);
  }
  const {
    data: tokenPnLData,
    isLoading
  } = useQuery({
    queryKey: ['pnlData', assetItem?.contract_address, assetItem.network],
    queryFn: async (): Promise<TPnLData | undefined> => {
      const data = await fetch(`${getUrls().INDEXER_URL}/portfolio/holdings?address=${assetItem?.network == ChainId.SOLANA ? PKP?.solanaAddress : PKP?.additionalEthAddress}&token=${assetItem?.contract_address}&chains=${assetItem?.network}`).then(res => res.json());
      const pnls = data?.pnls?.[0] ?? null;
      return pnls;
    },
    refetchInterval: 5000,
    enabled: Boolean(assetItem && assetItem?.contract_address && assetItem?.network && PKP)
  });
  const toggleDepositModal = () => {
    setDepositOpen(!isDepositOpen);
  };
  useEffect(() => {
    setModalOpen1(isModalOpen);
  }, [isModalOpen]);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };
  const rateChange = toRate(assetItem.quote_rate, assetItem.quote_rate_24h);
  const percentageAmount = rateChange / 100 * assetItem.usd_value;
  const portfolioAllocation = assetItem.usd_value / assetData.totalUsdValue * 100;
  function handleClick() {
    if (setLinkClickedLoading) {
      setLinkClickedLoading(true);
    }
    LogToMixpanel({
      pkp: PKP,
      eventName: EVENTS.portfolio.clickToken,
      category: CATEGORIES.portfolio,
      metaData: {
        tokenAddress: assetItem.contract_address,
        networkId: assetItem.network
      }
    });
  }
  const tokenImage = getTokenImage(assetItem);
  return <div className='flex items-center  w-full  md:hover:bg-genius-blue transition-all duration-300' data-sentry-component="PortfolioAssetItem" data-sentry-source-file="PortfolioAssetItem.tsx">
      <Link className='w-full  flex items-center justify-between  min-h-[70px] pl-4 ' onClick={handleClick} href={`/asset?address=${assetItem.contract_address}&networkId=${assetItem.network}&portfolio=true`} data-sentry-element="Link" data-sentry-source-file="PortfolioAssetItem.tsx">
        <div className={classNames(`${!isSwap ? 'w-5/12' : 'w-3/4'} cursor-pointer`)}>
          <div className='flex items-center relative'>
            <ImageWithFallback src={tokenImage} className='shrink-0 w-[32px] h-[32px] rounded-full' alt='network logo' width={100} height={100} data-sentry-element="ImageWithFallback" data-sentry-source-file="PortfolioAssetItem.tsx" />
            <ImageWithFallback src={getNetworkLogo(assetItem?.network)} className='w-[16px] h-[16px] bottom-1 left-4 absolute shrink-0' alt='network logo' width={10} height={10} data-sentry-element="ImageWithFallback" data-sentry-source-file="PortfolioAssetItem.tsx" />
            <div className='ml-3 flex flex-col items-start whitespace-nowrap'>
              <p className='text-base'>{toLocaleShortString(assetItem?.contract_name, 12)}</p>
              <p className='text-xs text-gray-400'>
                {toLocaleShortString(assetItem?.contract_ticker_symbol)}
              </p>
            </div>
          </div>
        </div>
      </Link>

      <div className={classNames(`flex flex-col ${!isSwap ? 'w-3/4 pr-4' : 'w-3/4 pr-0'} items-end`)}>
        <p className='text-base'>{`$${toSpecialFixed(assetItem.usd_value, 2)?.value}`}</p>
        {assetMode === 'Balance' && <p className='text-xs text-gray-400  text-right '>
            {`${toSpecialFixed(assetItem.formatted_balance, 2)?.value} ${toLocaleShortString(assetItem.contract_ticker_symbol, 3, true)}`}
          </p>}
        {assetMode === 'Returns (24hr)' && <div className='flex items-center'>
            {rateChange > 0 ? <>
                <TbTriangleFilled color='#34D399' size={12} />
                <p className='text-xs text-green-400 ml-1  text-right'>
                  {`$${toSpecialFixed(percentageAmount, 2)?.value}`}
                </p>
              </> : <>
                <TbTriangleInvertedFilled color='#FF5B5B' size={12} />
                <p className='text-xs text-red-400 ml-1  text-right'>
                  {`$${toSpecialFixed(Math.abs(percentageAmount), 2)?.value}`}
                </p>
              </>}
          </div>}
        {assetMode === 'Gains (24hr)' && <div className='flex items-center'>
            {rateChange > 0 ? <>
                <TbTriangleFilled color='#34D399' size={12} />
                <p className='text-xs text-green-400 ml-1  text-right'>
                  {`${toSpecialFixed(rateChange, 2)?.value}%`}
                </p>
              </> : <>
                <TbTriangleInvertedFilled color='#FF5B5B' size={12} />
                <p className='text-xs text-red-400 ml-1  text-right'>
                  {`${toSpecialFixed(Math.abs(rateChange), 2)?.value}%`}
                </p>
              </>}
          </div>}
        {assetMode === 'Allocation' && <div className='text-xs text-gray-400  text-right'>
            {toSpecialFixed(portfolioAllocation, 2).value}%
          </div>}
      </div>

      <div className={`flex pr-4 flex-col w-2/12 items-end justify-center ${isSwap && 'hidden'}`}>
        {!isSwap && <>
            <BsThreeDotsVertical size={24} onClick={toggleModal} className='text-genius-cream/50' />
            {isModalOpen ? <>


                <SlidingModal heightFit={true} isOpen={isModalOpen1} onClose={toggleModal} className='p-0'>
                  <div className='grid p-4 pb-0'>
                    <div className='flex items-center mb-1'>
                      <MobileBuySellController tokenAddressInput={assetItem.contract_address} network={assetItem.network} />
                    </div>
                    {!assetItem.contract_ticker_symbol?.includes('USDC') && !assetItem.contract_ticker_symbol?.includes('USDT') && <>
                          <Button className='rounded-full w-full lg:w-3/4 bg-genius-blue text-genius-cream h-14 mb-1' variant='purple'>
                            <div onClick={() => toggleFlex()} className='flex justify-center items-center w-full'>
                              Flex Your Gains 🎉
                            </div>
                          </Button>
                        </>}

                    <SendFundsController tokenData={{
                address: assetItem.contract_address,
                network: assetItem.network
              }} />
                    {/* SWAP BTN */}

                    {(assetItem.contract_ticker_symbol?.includes('USDC') || assetItem.contract_ticker_symbol?.includes('USDT')) && <>
                          <Button className='rounded-full w-full mt-1 lg:w-3/4 bg-genius-blue text-genius-cream h-14' variant='purple'>
                            <div onClick={() => toggleDepositModal()} className='flex justify-center items-center w-full'>
                              Deposit
                              <TbDownload className='text-lg ml-2' />
                            </div>
                          </Button>
                        </>}

                    {!assetItem.contract_ticker_symbol?.includes('USDC') && !assetItem.contract_ticker_symbol?.includes('USDT') && <Button className='rounded-full w-full mt-1 lg:w-3/4 bg-genius-blue text-genius-cream h-14' variant='purple'>
                          <div onClick={() => {
                  LogToMixpanel({
                    pkp: PKP,
                    eventName: EVENTS.portfolio.startTrade,
                    category: CATEGORIES.portfolio,
                    metaData: {
                      tokenAddress: assetItem.contract_address,
                      networkId: assetItem.network
                    }
                  });
                  resetAssets();
                  router.push(`/trade?address=${assetItem.contract_address}&networkId=${assetItem.network}&from=true`);
                }} className='flex justify-center items-center w-full'>
                            Swap
                            <IoIosSwap className='text-lg ml-2' />
                          </div>
                        </Button>}
                  </div>
                </SlidingModal>

                <SlidingModal heightFit={true} isOpen={isOpenFlex} onClose={toggleFlex} className='p-[0px!important]'>
                  <div className='m-2 mb-0'>
                    <FlexYourGains tokenAddressInput={assetItem.contract_address} network={assetItem.network} tokenPnLData={tokenPnLData} isLoading={isLoading} />
                  </div>
                </SlidingModal>
              </> : <></>}
          </>}

        <DepositHome isModalOpen={isDepositOpen} setIsModalOpen={toggleDepositModal} data-sentry-element="DepositHome" data-sentry-source-file="PortfolioAssetItem.tsx" />
      </div>
    </div>;
};